















































































import Vue from 'vue';

export default Vue.extend({
    name: 'VideoBox',
    methods: {
    scrollToTop() {
        window.scrollTo(0, 0);
    },
    },
});
